// Константы для Form6

// Функция для получения пустых данных формы
export const getEmptyFormData = () => {
  return {
    // Данные таблицы
    data: [{
      id: 1,
      yarus: '',           // Ярус
      dolya: '',           // Доля
      poroda: '',          // Порода
      sks: '',             // СКС
      otpad_obsh: '',      // Отпад (общ)
      otpad_tek: '',       // Отпад (тек)
      dolya_povrezhdennyh_po_prichinam: '',  // Доля повреждённых деревьев по причинам повреждения, % от запаса
      dolya_povrezhdennyh_dlya_ochaga: ''    // Доля повреждённых деревьев по причинам повреждения для определения очага, % от запаса
    }],
    // Общие поля для всех строк
    raschetnaya_ostatochnaya_polnota: '',  // Расчётная остаточная полнота
    klass_ustoychivosti_nasazhdeniya: '',   // Класс устойчивости насаждения
    // Рекомендуемые мероприятия
    recommended_measures: [{
      id: 1,
      rekvidmer: '',             // Вид (справочник ID 25)
      srokmzl: '', // Сроки проведения
      srekme: '',         // Площадь
      primechmzl: ''      // Примечание
    }],
    form6ValidationErrors: false // По умолчанию false, так как все поля необязательные
  };
};

